<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>{{ i18n.tr('Ontvangst') }}</ion-title>
    </ion-toolbar>
    <ion-toolbar>
        <ion-searchbar
            placeholder="Zoek op artikel, nr. of leverancier"
            (ionInput)="handleSearch($event)"
            [debounce]="300"
            [value]="currentFilter"
        ></ion-searchbar>
        <ion-buttons slot="end">
            <ion-button
                class="scan-button"
                fill="solid"
                size="small"
                (click)="doScan()"
                [hidden]="global.optHideScanBtn"
            >
                <ion-icon name="barcode"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" [hidden]="scanCamera">
    <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <div *ngIf="isLoading" class="ion-text-center ion-padding">
        <ion-spinner name="crescent"></ion-spinner>
    </div>
    <div *ngIf="!isLoading && errorMessage" class="ion-text-center ion-padding">
        <p>{{errorMessage}}</p>
    </div>
    <ion-accordion-group
        *ngIf="!isLoading && groupedRecords && groupedRecords.length > 0"
        [multiple]="false"
    >
        <ion-accordion
            *ngFor="let group of groupedRecords"
            [value]="group.POlev"
        >
            <ion-item slot="header" class="accordion-header">
                <ion-label>
                    <strong>{{ group.POlev }}</strong>
                </ion-label>
            </ion-item>
            <div class="ion-no-padding" slot="content">
                <ng-container *ngFor="let purchase of group.purchases">
                    <ion-item-divider class="inkoop-header">
                        <ion-label>Ink. Nr: {{ purchase.POLorder }}</ion-label>
                        <ion-button
                            class="alles-geleverd-button"
                            *ngIf="hasItemsToReceive(purchase)"
                            slot="end"
                            fill="solid"
                            (click)="$event.stopPropagation(); markPurchaseAsDone(purchase.POLorder)"
                            title="Mark all items in this purchase as received"
                        >
                            {{ i18n.tr("Alles Geleverd?") }}
                        </ion-button>
                        <ion-chip
                            *ngIf="!hasItemsToReceive(purchase)"
                            slot="end"
                            class="received-chip"
                        >
                            <ion-icon name="checkmark-done-outline"></ion-icon>
                            <ion-label class="received-chip-text">
                                {{i18n.tr("Vandaag ontvangen")}}</ion-label
                            >
                        </ion-chip>
                    </ion-item-divider>

                    <ion-list class="ion-no-padding">
                        <ion-item
                            *ngFor="let record of purchase.records"
                            [ngClass]="{'item-received': record.sort_group == 2}"
                            (click)="record.sort_group == 1 ? openOntvangstModal(record) : null"
                            [button]="record.sort_group == 1"
                            [detail]="record.sort_group == 1"
                            lines="full"
                        >
                            <ion-label>
                                <h2>{{ record.POLdescr }}</h2>
                                <p class="artikel-number">
                                    <span class="artikel-number-label"
                                        >Art. Nr:&nbsp;</span
                                    >
                                    <span
                                        class="artikel-number-value"
                                        *ngIf="record.POLartnr"
                                        >{{ record.POLartnr}}</span
                                    >
                                    <span
                                        class="artikel-number-value"
                                        *ngIf="!record.POLartnr"
                                        >N/A</span
                                    >
                                </p>
                                <p class="lev-artikel-number">
                                    <span class="lev-artikel-number-label"
                                        >Lev. Art. Nr:&nbsp;</span
                                    >
                                    <span
                                        class="lev-artikel-number-value"
                                        *ngIf="record.POLartnr"
                                        >{{ record.POLlevart}}</span
                                    >
                                    <span
                                        class="lev-artikel-number-value"
                                        *ngIf="!record.POLlevart"
                                        >N/A</span
                                    >
                                </p>
                                <p class="locatie">
                                    <span class="locatie-label"
                                        >{{i18n.tr("Locatie:")}}&nbsp;</span
                                    >
                                    <span
                                        class="locatie-value"
                                        *ngIf="record.Locatie"
                                        >{{ record.Locatie }}</span
                                    >
                                    <span
                                        class="locatie-value"
                                        *ngIf="!record.Locatie"
                                        >N/A</span
                                    >
                                </p>
                                <div class="ontvangst-details">
                                    <div class="detail-item">
                                        <span class="label"
                                            >{{ i18n.tr('Besteld') }}</span
                                        >
                                        <span class="value besteld"
                                            >{{ record.Besteld }}</span
                                        >
                                    </div>
                                    <div class="detail-item">
                                        <span class="label"
                                            >{{ i18n.tr('Ontvangen') }}</span
                                        >
                                        <span class="value ontvangen"
                                            >{{ record.Ontvangen }}</span
                                        >
                                    </div>
                                </div>
                                <div class="item-footer">
                                    <p class="eenheid">
                                        <span class="eenheid-label"
                                            >{{i18n.tr("Eenheid:")}}&nbsp;</span
                                        >
                                        <span
                                            class="eenheid-value"
                                            *ngIf="record.POLeenh"
                                            >{{ record.POLeenh }}</span
                                        >
                                        <span
                                            class="eenheid-value"
                                            *ngIf="!record.POLeenh"
                                            >N/A</span
                                        >
                                    </p>
                                    <p
                                        class="leverdatum"
                                        *ngIf="record.DatumType === 'Leverdatum'"
                                    >
                                        <span class="leverdatum-label"
                                            >{{i18n.tr("Leverdatum:")}}
                                            &nbsp;</span
                                        >
                                        <span class="leverdatum-value"
                                            >{{ record.Datum | date: 'dd MMM
                                            yyyy' }}</span
                                        >
                                    </p>
                                    <p
                                        class="ontvangstdatum"
                                        *ngIf="record.DatumType === 'Ontvangen'"
                                    >
                                        <span class="ontvangstdatum-label"
                                            >{{i18n.tr("Ontvangstdatumn:")}}
                                            &nbsp;</span
                                        >
                                        <span class="ontvangstdatum-value"
                                            >{{ record.Datum | date: 'dd MMM
                                            yyyy' }}</span
                                        >
                                    </p>
                                </div>
                            </ion-label>
                        </ion-item>
                    </ion-list>
                </ng-container>
            </div>
        </ion-accordion>
    </ion-accordion-group>
</ion-content>
